import {CmsButtonProps, Button, VerticalSpacer} from '../';
import React from 'react';
import styled from 'styled-components';
import {Typography} from '../typography/Typography';

const ArticleCalloutCardWrapper = styled.div`
    margin: 0 auto;
    max-width: ${(p) => p.theme.widths.article}px;
    background-color: ${(p) => p.theme.palette.background.paper};
    padding: ${(p) => p.theme.spacing(8)}px;
    ${(p) => p.theme.breakpoints.down('sm')} {
        padding: ${(p) => p.theme.spacing(6)}px;
    }
    box-sizing: border-box;
    text-align: center;
`;

export interface ArticleCalloutCardProps {
    title?: string;
    copy?: string;
    button?: CmsButtonProps;
}

export const ArticleCalloutCard = ({
    title = '',
    copy = '',
    button = {}
}: ArticleCalloutCardProps): JSX.Element => {
    return (
        <ArticleCalloutCardWrapper className={`copy-wrapper`}>
            {title && (
                <>
                    <Typography variant="h2"> {title}</Typography>
                    <VerticalSpacer variant={'eyebrow'} />
                </>
            )}

            {copy && (
                <>
                    <Typography variant="p">{copy}</Typography>
                    <VerticalSpacer variant="custom" spacing={4} />
                </>
            )}

            {button && button.label && (
                <>
                    <Button type={button.type} href={button.href}>
                        {button.label}
                    </Button>
                </>
            )}
        </ArticleCalloutCardWrapper>
    );
};
